import { useIsAuthenticated, useAuthUser } from "react-auth-kit"
import { Navigate } from "react-router-dom"
import React, { ReactNode } from "react"

interface CustomProtectedProps {
  userType: string
  children: ReactNode // Add this line to include the children prop in the type definition
}

const ProtectedRoute: React.FC<CustomProtectedProps> = ({
  children,
  userType,
}) => {
  const isAuthenticated = useIsAuthenticated()
  const authUser = useAuthUser()

  if (!isAuthenticated()) {
    return <Navigate to={`/${userType}/login`} />
  }

  if (
    userType === "admin" &&
    !["eventAdmin", "appAdmin"].includes(authUser()?.type)
  ) {
    return <Navigate to="/not-authorized" />
  }

  if (userType === "eventAdmin" && authUser()?.type !== "eventAdmin") {
    return <Navigate to="/not-authorized" />
  }

  if (userType === "appAdmin" && authUser()?.type !== "appAdmin") {
    return <Navigate to="/not-authorized" />
  }

  if (userType === "voter" && authUser()?.type !== "voter") {
    return <Navigate to="/not-authorized" />
  }

  return <>{children}</> // Render children directly
}

export default ProtectedRoute
